import types from '../actionTypes';

const INITIAL_STATE = {
  isFetchingAllSubjectsList : false,
  subjects: [],
  subjectsParam: [],
  errors: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SUBJECTS_FETCH_REQUEST:
      return {
        ...state,
        isFetchingAllSubjectsList: true,
      };
    case types.SUBJECTS_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingAllSubjectsList: false,
        subjects: action.payload.subjects,
      };
    case types.SUBJECTS_PARAM_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingAllSubjectsList: false,
        subjectsParam: action.payload.subjects,
      };
    case types.SUBJECTS_FETCH_FAIL:
      return {
        ...state,
        isFetchingAllSubjectsList: false,
        errors: action.payload.error,
      };
    default:
      return state;
  }
};
